import { RootState } from '@checkout/state';
import { Field } from 'formik';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { updatePaymentFieldsRequest } from '../../../reducers/checkout';
import { FormNames } from '../../../utils/formNames';
import { GroupTitle, InputBoxField, Section, TermsLink } from '../../presentational';
import messages from './../../../i18n/base-en';
import { required } from './../../../utils/validators';
import * as Styles from './ConsentGroupForm.scss';

interface IOwnProps {}

interface IConnectedProps {
  terms: boolean;
  title?: string;
}

interface IConnectetDispatchProps {
  updatePaymentFieldsRequest: typeof updatePaymentFieldsRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class ConsentGroupForm extends React.Component<Props, {}> {

  validateTemsField = (value: boolean) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    let error;
    const requiredError = required(value, formatMessage(messages.required_valid_error));

    if (requiredError) {
      error = requiredError;
    }

    return error;
  }

  render() {
    const { intl, title } = this.props;
    const { formatMessage } = intl;

    const renderTermsLabel = (url: string, isTermsLinkVisible: boolean) => (
      <Fragment>
        {formatMessage(messages.terms_and_conditions_label)}
        {isTermsLinkVisible && (
          <TermsLink
            variant="inline"
            label={`${formatMessage(messages.terms_and_conditions_link_label)} *`}
            url={url}
          />
        )}
      </Fragment>
    );

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.form}>
            {title && <GroupTitle title={title} />}
            <Section blockFor="Terms">
              <Field
                id={`${FormNames.consentGroup}.terms`}
                name={`${FormNames.consentGroup}.terms`}
                component={InputBoxField}
                required={true}
                semanticType="checkbox"
                validate={this.validateTemsField}
                label={renderTermsLabel(checkoutContextConfig.ui.consentGroup.termsLink.url,
                  checkoutContextConfig.ui.consentGroup.termsLink.isTermsLinkVisible)}
              />
            </Section>
          </div>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  terms: state.checkout.fieldsData.consentGroup && state.checkout.fieldsData.consentGroup.terms,
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {
      updatePaymentFieldsRequest,
    }
  ),
)(ConsentGroupForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ConsentGroupForm/ConsentGroupForm.tsx